import Position from './Position';

/**
 * Class describing the values and functions of a RouteNode
 * RouteNode objects are used by the Routing service to determine the optimal route
 * between two Waypoints
 * 
 * @export {RouteNode}
 * @class RouteNode
 */
export default class RouteNode {
    constructor (nodeWaypoint, nodeParent, walkability) {
        this._waypoint = nodeWaypoint;
        const standardWalkability = 1.0;

        if (nodeParent != null) {
            this._parent = nodeParent;
            this._distanceToParent = Position.getDistance(nodeWaypoint.position, nodeParent.waypoint.position);
            this._distanceToOrigin = this._distanceToParent + nodeParent.distanceToOrigin;

            // assume that 1.0f is the standard walkability (e.g. just a flat surface with not incline/decline), this
			// can be changed as needed
			this._costToParent = (standardWalkability / walkability) * this._distanceToParent;
			this._costToOrigin = this._costToParent + this._parent.costToOrigin;
        } else {
            this._distanceToParent = 0.0;
            this._distanceToOrigin = 0.0;
            this._costToParent = 0.0;
            this._costToOrigin = 0.0;
        }
    }

    get waypoint() {
        return this._waypoint;
    }

    get parent() {
        return this._parent;
    }

    get distanceToOrigin() {
        return this._distanceToOrigin;
    }

    get distanceToParent() {
        return this._distanceToParent;
    }

    get costToParent() {
        return this._costToParent;
    }

    get costToOrigin() {
        return this._costToOrigin;
    }

    hasParent() {
        if (this._parent === null || this._parent === undefined) {
            return false;
        } else {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/classes/RouteNode.js